import {h, Fragment} from "preact"
import { useLoadMore } from '@nosto/preact';
import { useAppState } from '@nosto/preact';
import Progressbar from "./Progressbar"


const parseInteger = (value) => (value && !Number.isNaN(value) ? Number.parseInt(`${value}`) : 0);

export default function LoadMoreButton({ pageSize }) {
    const { loadMore, href } = useLoadMore(pageSize);
    const { query, response } = useAppState();

    const from = parseInteger(query.products?.from);
    const size = parseInteger(response.products.size);
    const total = parseInteger(response.products.total);
    const to = from + size;

    // console.log('QUERY', query);
    // console.log('RESPONSE', response);
    // console.log('TO', to, 'TOTAL', total, 'SIZE', size, 'FROM', from);

    const style = {
        color: '#000',
        fontSize: '18px',
        background: '#c6a95a',
        padding: '10px 20px',
        borderRadius: '3px',
        boxShadow: 'inset 0 0 transparent, inset 0 -3px #0000001a',
        transition: 'all 0.2s',
        fontWeight: 700,
        fontFamily: '"Goudy Old Style", serif',
    };

    if (to <= total) {
        return (
            <div class="ns-load-more-container ns-d-flex ns-flex-column ns-align-items-center">
                <div>
                    Showing {total < to ? total : to} of {total} items
                </div>
                <Progressbar />
                <div class="ns-d-flex ns-w-100 ns-justify ns-justify-content-center ns-w-100">
                    <a style={style} class="ns-load-more-button ns-act-btn" onClick={loadMore} href={href}>
                        More Results
                    </a>
                </div>
            </div>
        );
    } else return "";
}
